/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { useRef } from "react";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { checkActionAuthorization, downloadCsvFile } from "../../../service/shared.service";
import { TBSStoreDataEntity, TBSStoreFilterReq } from "../../../interface/tbs-tracker/tbs-store";
import { APIResponseEntity } from "../../../interface/api-responce";
import { AxiosResponse } from "axios";
import { toastOptObj } from "../../../utils/constants";
import { APIExportTbsStoreItem, APIGetTbsDDl, APIGetTbsStoreList, APIGetTBSSticker, APIGetTBSDetails } from "../../../service/api-service";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import IssueMaterialDialog from "../tbs-sender/components/Issued-material-dialogbox";
import CommenDialog from "../tbs-sender/components/dialogbox";
import StickerPreviewDialog from "../tbs-sender/components/download-sticker-dialogbox";
import FabricationCodeDialog from "./components/fabrication-code-dialogbox";
import ReceiverDetailsModal from "../tbs-sender/components/receiver-details-modal";
import ReceiverDetailsIcon from "../tbs-sender/components/receiver-details-icon";
import { isReceiverReportMatched } from "../../../utils/tbs-verification";
import { GetTBSDetailsResEntity, TBSOfficeDDLEntity, TBSUserDDLEntity } from "../../../interface/tbs-tracker/send-tbs";
import { StorageKeyEnum } from "../../../utils/enum";
import { IsStringNullEmptyOrUndefined } from "../../../utils/null-check";
import { UserInfoEntity } from "../../../interface";


type TBSStoreLocationState = {
    status?: string;
};
const statusDDL: { label: string, value: string }[] = [
    { label: "In Transit", value: "in-transit" },
    { label: "Received", value: "received" },
    { label: "Semi Issued", value: "semi-issued" },
    { label: "Issued", value: "issued" },
    { label: "Returned", value: "returned" },
];
const statusLabelMap: Record<string, string> = {
    "in-transit": "In Transit",
    received: "Received",
    "semi-issued": "Semi Issued",
    issued: "Issued",
    returned: "Returned",
};

// Skin and handle are issued from separate pools. A TBS marked "issued" while some handles are still not issued
// (the skins used up the old shared pool) stays open for the handles.
const hasPendingHandlesWhenIssued = (row: TBSStoreDataEntity): boolean =>
    row.status === "issued" && (row.handleCount ?? 0) > (row.issuedHandleQty ?? 0);

// the receiver's answers exist from the moment the store has verified the TBS (also when every item was returned)
const hasReceiverDetails = (row: TBSStoreDataEntity): boolean => ["received", "semi-issued", "issued", "consumed", "returned"].includes(row.status);

const WORK_ORDER_NOT_GENERATED_NOTE = "Material can be issued once the work order is generated";

// the sticker carries the receipt: it can be downloaded once the store has received the TBS (not while in transit, not after everything was returned)
const canDownloadSticker = (row: TBSStoreDataEntity): boolean => ["received", "semi-issued", "issued", "consumed"].includes(row.status);
const STICKER_NOT_RECEIVED_NOTE = "Sticker can be downloaded once the TBS is received";

export default function TBSStore() {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as TBSStoreLocationState | undefined;
    const officeMultiSelectRef = useRef<any>(null);
    const salesPersonMultiSelectRef = useRef<any>(null);
    const statusMultiSelectRef = useRef<any>(null);
    const [tempOffice, setTempOffice] = useState<string[]>([]);
    const [tempSalesPerson, setTempSalesPerson] = useState<string[]>([]);
    const [tempStatus, setTempStatus] = useState<string[]>(locationState?.status ? [locationState.status] : []);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [totalRecords, setTotalRecords] = useState<number>(100);
    const [officesAndUsers, setOfficesAndUsers] = useState<TBSOfficeDDLEntity[]>([]);
    const [userDDL, setUserDDL] = useState<TBSUserDDLEntity[]>([]);
    const [showIssueDialog, setShowIssueDialog] = useState<boolean>(false);
    const [receiverDetailsTbs, setReceiverDetailsTbs] = useState<TBSStoreDataEntity | null>(null);
    const [receiverDetailsData, setReceiverDetailsData] = useState<GetTBSDetailsResEntity | null>(null);
    const [isReceiverDetailsOpen, setIsReceiverDetailsOpen] = useState<boolean>(false);
    const [rows, setRows] = useState<TBSStoreDataEntity[]>([]);
    const [selectedTBS, setSelectedTBS] = useState<TBSStoreDataEntity | null>(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState<boolean>(false);
    const [issuedQty, setIssuedQty] = useState<{ skin: number; handle: number }>({ skin: 0, handle: 0 });
    const [showFabricationDialog, setShowFabricationDialog] = useState<boolean>(false);
    const [showStickerDialog, setShowStickerDialog] = useState<boolean>(false);
    const [visibleOrder, setVisibleOrder] = useState<string>("");
    console.log(visibleOrder)
    const [filterReq, setFilterReq] = useState<TBSStoreFilterReq>({
        APICallCount: 0,
        pageNumber: 0,
        pageSize: 10,
        searchByTBSNo: "",
        filterByOfficeIds: "",
        filterBySalesHeadIds: "",
        filterByCreatedByIds: "",
        status: locationState?.status === "in-transit" ? "in-transit" : "",
        sortColumn: "tbsNo",
        sortOrder: "desc",
    });

    const fetchTBSStoreList = async (): Promise<void> => {
        setIsLoading(true);

        const resp: AxiosResponse<APIResponseEntity> = await APIGetTbsStoreList(filterReq);

        setIsLoading(false);

        setRows([]);
        setTotalRecords(0);

        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (
                    axiosResp &&
                    axiosResp.data &&
                    axiosResp.status &&
                    axiosResp.statusCode === 200
                ) {
                    const paginateResp = axiosResp.data;

                    setRows(paginateResp.data);

                    if (
                        Array.isArray(paginateResp.totalCount) &&
                        paginateResp.totalCount.length > 0
                    ) {
                        setTotalRecords(paginateResp.totalCount[0].count);
                    }
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            } else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }
    };

    const fetchOfficeAndUser = async (): Promise<void> => {
        const resp: AxiosResponse<APIResponseEntity> = await APIGetTbsDDl();
        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const ddlData = axiosResp.data[0];
                    setOfficesAndUsers(ddlData.officeSalesPerson);
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            } else {
                toast.error(resp.data?.message || "Export failed.", {
                    ...toastOptObj,
                });
            }
        }
    };

    const exportTBSStoreData = async () => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIExportTbsStoreItem();
        setIsLoading(false);
        if (!resp || !resp.data || resp.status !== 200) {
            toast.error(resp.data.message, { ...toastOptObj });
            setIsLoading(false);
            return;
        }

        const axiosResp: APIResponseEntity = resp.data;

        if (
            !axiosResp ||
            !axiosResp.data ||
            !axiosResp.status ||
            axiosResp.statusCode !== 200
        ) {
            toast.error(axiosResp.message, { ...toastOptObj });
            setIsLoading(false);
            return;
        }

        const excelUrl = axiosResp.data.xlsxUrl;
        if (!excelUrl || IsStringNullEmptyOrUndefined(excelUrl)) {
            toast.error("Excel not found", { ...toastOptObj });
            setIsLoading(false);
            return;
        }

        const fileName: string = excelUrl.split("/").pop();
        await downloadCsvFile(excelUrl, fileName);
    }

    useEffect(() => {
        fetchTBSStoreList();
    }, [filterReq.APICallCount]);

    useEffect(() => {
        fetchOfficeAndUser();
        const userStr = localStorage.getItem(StorageKeyEnum.JB_GLASS_USER_INFO);

        if (userStr && !IsStringNullEmptyOrUndefined(userStr)) {
            const userInfo: UserInfoEntity = JSON.parse(userStr);
            setVisibleOrder(userInfo.visibleOrders);
        }

        const element = document.querySelector(".pageTop");

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, []);
    useEffect(() => {
        if (visibleOrder !== "selfOffice") {
            return;
        }

        if (rows.length === 0 || officesAndUsers.length === 0) {
            return;
        }

        const officeName = rows[0].officeName.trim().toLowerCase();

        const matchedOffice = officesAndUsers.find(
            (office) =>
                office.officeName.trim().toLowerCase() === officeName
        );
        if (!matchedOffice) return;
        setTempOffice([matchedOffice.officeId]);
        setUserDDL(matchedOffice.users);
    }, [rows, officesAndUsers]);

    const resetFilters = () => {
        setTempOffice([]);
        setTempSalesPerson([]);
        setTempStatus([]);
        setUserDDL([]);

        setFilterReq((prev) => ({
            ...prev,
            APICallCount: prev.APICallCount + 1,
            pageNumber: 0,
            pageSize: 10,
            searchByTBSNo: "",
            filterByOfficeIds: "",
            filterBySalesHeadIds: "",
            status: "",
            sortColumn: "tbsNo",
            sortOrder: "desc",
        }));

        navigate("/TBS/tbs-store", {
            replace: true,
            state: {},
        });
    };

    const statusTemplate = (rowData: TBSStoreDataEntity) => {

        let className = "";

        switch (rowData.status) {
            case "issued":
                className = "text-success";
                break;

            case "semi-issued":
                className = "text-warning";
                break;

            case "received":
                className = "text-danger";
                break;

            case "returned":
                className = "text-secondary";
                break;

            default:
                className = "text-primary";
        }

        return (
            <span className={`fw-bold ${className}`}>
                {statusLabelMap[rowData.status] ?? rowData.status}
            </span>
        );
    };


    const handleDownloadSticker = async (rowData: TBSStoreDataEntity) => {
        if (!rowData._id) return;
        try {
            setIsLoading(true);
            const resp = await APIGetTBSSticker(rowData._id);
            setIsLoading(false);
            if (resp && resp.data && resp.data.status) {
                const downloadObj = resp.data.data?.data || resp.data.data;
                const stickerUrl = downloadObj && !IsStringNullEmptyOrUndefined(downloadObj.AWSFilePath)
                    ? downloadObj.AWSFilePath
                    : (downloadObj ? downloadObj.pdfUrl : "");
                if (!IsStringNullEmptyOrUndefined(stickerUrl)) {
                    window.open(stickerUrl, "_blank", "noopener,noreferrer");
                } else {
                    toast.error(resp.data.message || "Failed to generate sticker PDF", toastOptObj);
                }
            } else {
                toast.error(resp?.data?.message || "Failed to generate sticker PDF", toastOptObj);
            }
        } catch (error: any) {
            setIsLoading(false);
            toast.error(error?.response?.data?.message || error?.message || "Failed to download sticker", toastOptObj);
        }
    };

    // same as Send For TBS: the page loader covers the fetch and the popup opens with the data already in it
    const handleOpenReceiverDetails = async (rowData: TBSStoreDataEntity): Promise<void> => {
        if (!rowData?._id) return;
        setIsLoading(true);
        try {
            const resp = await APIGetTBSDetails(rowData._id);
            if (resp && resp.data && resp.status === 200) {
                const apiResp = resp.data;
                if (apiResp && apiResp.statusCode === 200 && apiResp.data) {
                    setReceiverDetailsData(apiResp.data);
                    setReceiverDetailsTbs(rowData);
                    setIsReceiverDetailsOpen(true);
                } else {
                    toast.error(
                        apiResp.message || apiResp.errorMsg || "Unable to fetch TBS receiver details.",
                        { ...toastOptObj }
                    );
                }
            } else {
                toast.error(
                    resp?.data?.message || "Unable to fetch TBS receiver details.",
                    { ...toastOptObj }
                );
            }
        } catch (err: any) {
            toast.error(err?.message || "Failed to fetch receiver details.", {
                ...toastOptObj,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const actionTemplate = (rowData: TBSStoreDataEntity) => {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minWidth: "160px", gap: "15px" }}
            >
                {rowData.status === "in-transit" && checkActionAuthorization("update", "TBS Store") && (
                    <img
                        src="assets/images/edit-icon.svg"
                        alt="Verify TBS Items"
                        title="Verify TBS Items"
                        onClick={() => navigate(`/TBS/verify-tbs-item/${rowData._id}`)}
                        className="cursor-pointer"
                    />
                )}
                {checkActionAuthorization("view", "TBS Store") &&
                    <img
                        src="assets/images/eye.svg"
                        alt="View TBS Items"
                        title="View TBS Items"
                        className="cursor-pointer"
                        onClick={() => {
                            navigate(`/TBS/view-tbs-store-item/${rowData._id}`)
                        }}
                    />
                }
                {hasReceiverDetails(rowData) && checkActionAuthorization("view", "TBS Store") &&
                    <ReceiverDetailsIcon
                        isMatched={isReceiverReportMatched(rowData.qty, rowData.receivedQty, rowData.hasReceiverChange)}
                        onClick={() => handleOpenReceiverDetails(rowData)}
                    />
                }
                {checkActionAuthorization("upgrade", "Allow User To Download Stickers") &&
                    <img
                        src="assets/images/download.svg"
                        alt="Download"
                        title={canDownloadSticker(rowData) ? "Download Stickers" : STICKER_NOT_RECEIVED_NOTE}
                        className={canDownloadSticker(rowData) ? "cursor-pointer" : "cursor-not-allowed"}
                        style={canDownloadSticker(rowData) ? undefined : { opacity: 0.4 }}
                        onClick={() => {
                            if (!canDownloadSticker(rowData)) {
                                toast.error(STICKER_NOT_RECEIVED_NOTE, toastOptObj);
                                return;
                            }
                            handleDownloadSticker(rowData);
                        }}
                    />
                }
                {checkActionAuthorization("upgrade", "Allow User To Issue Material") && (rowData.status === "received" || rowData.status === "semi-issued" || hasPendingHandlesWhenIssued(rowData)) &&
                    <img
                        src="assets/images/issue-material.svg"
                        alt="Issue Material"
                        title={rowData.isWorkOrderGenerated ? "Issue Material" : WORK_ORDER_NOT_GENERATED_NOTE}
                        className={rowData.isWorkOrderGenerated ? "cursor-pointer" : "cursor-not-allowed"}
                        style={rowData.isWorkOrderGenerated ? undefined : { opacity: 0.4 }}
                        onClick={() => {
                            if (!rowData.isWorkOrderGenerated) {
                                toast.error(WORK_ORDER_NOT_GENERATED_NOTE, toastOptObj);
                                return;
                            }
                            setSelectedTBS(rowData);
                            setShowIssueDialog(true);
                        }}
                    />
                }
                {checkActionAuthorization("upgrade", "Allow User To Capture Fabrication Code") && rowData.handleCount > 0 && (rowData.status === "received" || rowData.status === "semi-issued" || hasPendingHandlesWhenIssued(rowData)) &&
                    <img
                        src="assets/images/file_list.svg"
                        alt="Capture Fabrication Code"
                        title={`Capture Fabrication Code (${rowData.fabricationCodeCount ?? 0} of ${rowData.handleCount} handles done)`}
                        className="cursor-pointer"
                        onClick={() => {
                            setSelectedTBS(rowData);
                            setShowFabricationDialog(true);
                        }}
                    />
                }
                {checkActionAuthorization("upgrade", "Allow User To Return Extra Items") && (rowData.status === "received" || rowData.status === "semi-issued" || rowData.status === "issued") &&
                    <img
                        src="assets/images/refresh-circle.svg"
                        alt="Return Extra Items"
                        title="Return Extra Items"
                        className="cursor-pointer"
                        onClick={() => navigate(`/TBS/return-extra-items/${rowData._id}`)}
                    />
                }
            </div>
        );
    };
    const filterTemplateTBSNo = () => (
        <InputText
            value={filterReq.searchByTBSNo}
            placeholder="Search by TBS No."
            onChange={(e) =>
                setFilterReq((prev) => ({
                    ...prev,
                    searchByTBSNo: e.target.value,
                    APICallCount: prev.APICallCount + 1,
                }))
            }
        />
    );

    const renderMultiSelectFilter = (
        ref: any,
        tempValue: string[],
        setTempValue: React.Dispatch<React.SetStateAction<string[]>>,
        options: any[],
        optionLabel: string,
        optionValue: string,
        field: keyof TBSStoreFilterReq,
        onApply?: (value: string[]) => void,
        disabled = false
    ) => {
        const appliedValues =
            typeof filterReq[field] === "string" && filterReq[field]
                ? (filterReq[field] as string).split(",").filter(Boolean)
                : [];
        const panelFooterTemplate = () => (
            <div className="p-2">
                <button
                    className="p-button p-button-sm"
                    disabled={
                        JSON.stringify(tempValue) ===
                        JSON.stringify(appliedValues)
                    }
                    onClick={() => {
                        onApply?.(tempValue);
                        setFilterReq(prev => ({
                            ...prev,
                            [field]: tempValue.join(","),
                            pageNumber: 0,
                            APICallCount: prev.APICallCount + 1,
                        }));

                        ref.current.hide();
                    }}
                >
                    Apply
                </button>
            </div>
        );

        return (
            <MultiSelect
                ref={ref}
                value={tempValue}
                options={options}
                optionLabel={optionLabel}
                optionValue={optionValue}
                filter
                disabled={disabled}
                placeholder="Select"
                maxSelectedLabels={1}
                panelFooterTemplate={panelFooterTemplate}
                onChange={(e) => setTempValue(e.value)}
                onHide={() => setTempValue(appliedValues)}
            />
        );
    };

    const onTableSort = (e: DataTableSortEvent) => {
        if (e.sortField && e.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: String(e.sortField),
                sortOrder: e.sortOrder === 1 ? "asc" : "desc",
                pageNumber: 0,
                APICallCount: prev.APICallCount + 1,
            }));
        }
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFilterReq(prev => ({
            ...prev,
            pageNumber: event.page,
            pageSize: event.rows,
            APICallCount: prev.APICallCount + 1,
        }));
    }

    const showOfficeColumn = visibleOrder === "all";
    const showSalesHeadColumn = visibleOrder === "all" || visibleOrder === "selfOffice";
    return (
        <>
            <Loader isLoading={isLoading} />

            <div className="content-wrapper">
                <div className="d-flex justify-content-between align-items-center mb-4 pageTop">
                    <h2 className="fw-bold mb-0">
                        TBS Tracker
                    </h2>
                    {checkActionAuthorization("upgrade", "Export TBS Store Items") &&
                        <button className="btn btn-success"
                            onClick={exportTBSStoreData}
                        >
                            Export
                        </button>
                    }
                </div>
                <div className="bg-white rounded-3 shadow-sm mt-4 p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="fw-bold mb-0">
                            Store
                        </h4>
                        <span
                            className="resetFilters text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={resetFilters}
                        >
                            Reset Filters
                        </span>
                    </div>
                    <div className="w-100">
                        <DataTable
                            value={rows}
                            filterDisplay="row"
                            responsiveLayout="scroll"
                            className="p-datatable-sm"
                            emptyMessage="No Records Found"
                            sortField={filterReq.sortColumn}
                            sortOrder={filterReq.sortOrder === "asc" ? 1 : -1}
                            onSort={onTableSort}
                        >
                            <Column
                                field="tbsNo"
                                header="TBS No."
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={filterTemplateTBSNo}
                                style={{ minWidth: "170px" }}
                            />
                            {showOfficeColumn &&
                                <Column
                                    field="officeName"
                                    header="Office Name"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={() =>
                                        renderMultiSelectFilter(
                                            officeMultiSelectRef,
                                            tempOffice,
                                            setTempOffice,
                                            officesAndUsers,
                                            "officeName",
                                            "officeId",
                                            "filterByOfficeIds",
                                            (selectedOfficeIds) => {
                                                const users = officesAndUsers
                                                    .filter((office) =>
                                                        selectedOfficeIds.includes(office.officeId)
                                                    )
                                                    .flatMap((office) => office.users);

                                                setUserDDL(users);
                                                setTempSalesPerson([]);

                                                setFilterReq(prev => ({
                                                    ...prev,
                                                    filterBySalesHeadIds: ""
                                                }));
                                            }
                                        )
                                    }
                                    style={{ minWidth: "190px" }}
                                />}

                            {showSalesHeadColumn &&
                                <Column
                                    field="salesPerson"
                                    header="Sales Person"
                                    sortable
                                    filter
                                    showFilterMenu={false}
                                    filterElement={() =>
                                        renderMultiSelectFilter(
                                            salesPersonMultiSelectRef,
                                            tempSalesPerson,
                                            setTempSalesPerson,
                                            userDDL,
                                            "displayName",
                                            "salesPersonId",
                                            "filterBySalesHeadIds",
                                            undefined,
                                            tempOffice.length === 0
                                        )
                                    }
                                    style={{ minWidth: "190px" }}
                                />}

                            <Column
                                field="qty"
                                header="QTY"
                                sortable
                                style={{
                                    minWidth: "90px",
                                    textAlign: "center",
                                }}
                            />

                            <Column
                                field="receivedQty"
                                header="Received Qty"
                                sortable
                                body={(rowData: TBSStoreDataEntity) =>
                                    rowData.receivedQty ?? "-"
                                }
                                style={{
                                    minWidth: "140px",
                                    textAlign: "center",
                                }}
                            />

                            <Column
                                field="issueQty"
                                header="Issue Qty"
                                sortable
                                style={{
                                    minWidth: "120px",
                                    textAlign: "center",
                                }}
                            />

                            <Column
                                field="status"
                                header="Status"
                                body={statusTemplate}
                                sortable
                                filter
                                showFilterMenu={false}
                                filterElement={() =>
                                    renderMultiSelectFilter(
                                        statusMultiSelectRef,
                                        tempStatus,
                                        setTempStatus,
                                        statusDDL,
                                        "label",
                                        "value",
                                        "status"
                                    )
                                }
                                style={{ minWidth: "180px" }}
                            />
                            {(checkActionAuthorization("upgrade", "Allow User To Download Stickers") ||
                                checkActionAuthorization("upgrade", "Allow User To Issue Material") ||
                                checkActionAuthorization("upgrade", "Allow User To Capture Fabrication Code") ||
                                checkActionAuthorization("upgrade", "Allow User To Return Extra Items") ||
                                checkActionAuthorization("view", "TBS Store")) &&
                                <Column
                                    header="Action"
                                    body={actionTemplate}
                                    style={{
                                        minWidth: "220px",
                                        textAlign: "center",
                                    }}
                                />
                            }
                        </DataTable>
                        {totalRecords > 0 && (
                            <PrimePaginator
                                onPageChange={onPageChange}
                                pageNumber={filterReq.pageNumber}
                                pageSize={filterReq.pageSize}
                                totalRecords={totalRecords}
                            />
                        )}
                    </div>
                </div>
            </div>

            <ReceiverDetailsModal
                isOpen={isReceiverDetailsOpen}
                onClose={() => {
                    setIsReceiverDetailsOpen(false);
                    setReceiverDetailsTbs(null);
                    setReceiverDetailsData(null);
                }}
                viewData={receiverDetailsData}
                tbsId={receiverDetailsTbs?._id}
                tbsNo={receiverDetailsData?.tbsNumber || receiverDetailsTbs?.tbsNo}
            />

            {selectedTBS && (
                <>
                    <IssueMaterialDialog
                        isOpen={showIssueDialog}
                        onClose={() => setShowIssueDialog(false)}
                        onIssue={(skinQty: number, handleQty: number) => {
                            setIssuedQty({ skin: skinQty, handle: handleQty });
                            setShowIssueDialog(false);
                            setShowSuccessDialog(true);
                            fetchTBSStoreList();
                        }}
                        tbsId={selectedTBS._id ?? ""}
                        tbsNumber={selectedTBS.tbsNo ?? ""}
                        ReceivedQty={selectedTBS.receivedQty ?? 0}
                        alreadyIssuedQty={selectedTBS.issueQty ?? 0}
                        alreadyIssuedSkinQty={selectedTBS.issuedSkinQty ?? 0}
                        alreadyIssuedHandleQty={selectedTBS.issuedHandleQty ?? 0}
                        handleCount={selectedTBS.handleCount ?? 0}
                        fabricationCodeCount={selectedTBS.fabricationCodeCount ?? 0}
                    />
                    <CommenDialog
                        isOpen={showSuccessDialog}
                        title="Issued to Production"
                        description={
                            <>
                                <strong>{issuedQty.skin + issuedQty.handle}</strong> pcs{" "}
                                {issuedQty.handle > 0 && <>(Skin {issuedQty.skin}, Handle {issuedQty.handle}){" "}</>}
                                of <strong>TBS No. {selectedTBS.tbsNo}</strong>{" "}
                                issued to Production (skin {(selectedTBS.issuedSkinQty ?? 0) + issuedQty.skin} of{" "}
                                {Math.max((selectedTBS.receivedQty ?? 0) - (selectedTBS.handleCount ?? 0), 0)}
                                {(selectedTBS.handleCount ?? 0) > 0 && <>, handle {(selectedTBS.issuedHandleQty ?? 0) + issuedQty.handle} of {selectedTBS.handleCount}</>}).
                            </>
                        }
                        buttonText="Close"
                        onClose={() => setShowSuccessDialog(false)}
                    />
                    <StickerPreviewDialog
                        isOpen={showStickerDialog}
                        onClose={() => setShowStickerDialog(false)}
                        tbsId={selectedTBS._id}
                        tbsNumber={selectedTBS.tbsNo}
                        issuedQty={selectedTBS.issueQty}
                    />
                    <FabricationCodeDialog
                        isOpen={showFabricationDialog}
                        onClose={() => setShowFabricationDialog(false)}
                        onSaved={fetchTBSStoreList}
                        tbsId={selectedTBS._id ?? ""}
                        tbsNumber={selectedTBS.tbsNo ?? ""}
                    />
                </>
            )
            }
        </>
    );
}